import React from 'react';
import './Badge.sass';
import cx from 'classnames';


export default function Badge({type}) {
  return (
    <div className={cx('badge', `badge--${type}`)}>
      <span className="badge__label"/>
    </div>
  );
}




// WEBPACK FOOTER //
// ./components/badge/Badge.js